import { useCallback } from 'react';

import type { PetitionHeadlineBandit, PetitionMitaBandit } from 'src/app/pages/psf/share/pageContext';
import { useCurrentUserId } from 'src/app/shared/hooks/session';

import type { BanditVariant } from '../../types';

type Result = (
	bandit: PetitionHeadlineBandit | PetitionMitaBandit | undefined,
	genPathSuffix: (data: { experimentName: string; variantName: string; currentUserId: string }) => string,
) => BanditVariant | undefined;

export function useGenHeadlineOrMitaBanditVariantData(): Result {
	const currentUserId = useCurrentUserId();

	return useCallback(
		(bandit, genPathSuffix) => {
			if (!bandit) return undefined;
			// TODO we don't need to handle guest bandit urls for the petition page
			// but this might need to be extended if extracted to be used in other pages
			if (!currentUserId) return undefined;

			const { experimentName, selectedVariant } = bandit;
			if (!selectedVariant) return undefined;
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			const { data, variantName } = selectedVariant;
			// eslint-disable-next-line prefer-destructuring, @typescript-eslint/no-unsafe-member-access
			const message = data.message as string;

			return {
				experimentName,
				variantName,
				message,
				urlParameters: {
					utm_content: `${experimentName}:${variantName}`,
				},
				pathSuffix: genPathSuffix({ experimentName, variantName, currentUserId }),
			};
		},
		[currentUserId],
	);
}
